import "./style.css";
import { defineComponent as t, defineAsyncComponent as n, resolveComponent as r, openBlock as p, createBlock as s } from "vue";
import { b as c, _ as i } from "./index-up0O4QOR.js";
const a = () => import("./index-up0O4QOR.js").then((e) => e.K).then((e) => e.default).catch((e) => {
  throw console.error(
    "Error while attempting to dynamically import component Block at ../block.vue",
    e
  ), e;
}), l = t({
  name: "repeated-block",
  components: { Block: n(a) },
  props: ["repeatContext", "block", "registeredComponents", "linkComponent"],
  data() {
    return { store: this.repeatContext };
  },
  provide() {
    const e = this;
    return {
      [c.key]: e.store
    };
  },
  watch: {
    onUpdateHook0: {
      handler() {
        this.store = this.repeatContext;
      },
      immediate: !0
    }
  },
  computed: {
    onUpdateHook0() {
      return {
        0: this.repeatContext
      };
    }
  }
});
function m(e, d, k, C, h, u) {
  const o = r("Block");
  return p(), s(o, {
    block: e.block,
    context: e.store,
    registeredComponents: e.registeredComponents,
    linkComponent: e.linkComponent
  }, null, 8, ["block", "context", "registeredComponents", "linkComponent"]);
}
const b = /* @__PURE__ */ i(l, [["render", m]]);
export {
  b as default
};
